import type { FC } from 'react';

import { DealListPanel } from '@entities/Deal';

export interface MerchantRequestsProps {
  onOpenDeal: (dealId: string) => void;
}

export const MerchantRequests: FC<MerchantRequestsProps> = ({ onOpenDeal }) => (
  <DealListPanel source="merchant_inbound" onOpenDeal={onOpenDeal} />
);

MerchantRequests.displayName = 'MerchantRequests';
